module.exports = __webpack_public_path__ + "static/img/wing_633.2d7bc29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/wing_633.jpg
// module id = oEgp
// module chunks = 0